import React from 'react';

import { Spinner } from '@iwoca/orion';
import { clsx } from 'clsx';

import styles from './Button.module.css';

type TProps = {
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'small' | 'medium' | 'large';
  iconOnly?: boolean;
  href?: string;
  disabled?: boolean;
  loading?: boolean;
  noShadow?: boolean;
} & (
  | React.AnchorHTMLAttributes<HTMLAnchorElement>
  | React.ButtonHTMLAttributes<HTMLButtonElement>
);

export const Button = ({
  className,
  href,
  variant = 'primary',
  size = 'medium',
  iconOnly,
  children,
  disabled,
  loading = false,
  noShadow = false,
  ...props
}: TProps) => {
  const classNames = clsx(
    styles.button,
    styles[variant],
    styles[size],
    { [styles.iconOnly]: iconOnly },
    { [styles.disabled]: disabled || loading },
    { [styles.loading]: loading },
    { [styles.noShadow]: noShadow },
    className,
  );

  if (href !== undefined) {
    return (
      <a
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
        href={href}
        className={classNames}
        aria-busy={loading}
      >
        <>
          {loading ? (
            <Spinner className={styles.spinner} size={size} />
          ) : (
            children
          )}
        </>
      </a>
    );
  }

  return (
    <button
      {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
      className={classNames}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {loading ? (
        <Spinner className={styles.spinner} size={size} />
      ) : (
        <div className={styles.buttonContent}>{children}</div>
      )}
    </button>
  );
};
